export default __webpack_public_path__ + "static/media/Group 5141.dc2175f9.svg";